<!--
 数据字典选择框 带查询
 只支持多选，别改，单选另外弄
-->
<template>
  <a-select
          :disabled="disabled"
           v-model="currentValue"
          :allowClear="allowClear"
          :placeholder="placeholder"
          :mode="mode"
          style="width: 280px"
          :showSearch=true
          @change="search"
          optionLabelProp="label"
          optionFilterProp="label"
          enter-button="Search"
          :getPopupContainer="trigger => trigger.parentNode"
  >
    <a-select-option v-for="item in options"
                     :key="item.id" :value="item.value" :label="item.name">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'DictSearchSelect',
  props: {
    disabled: {
      type: Boolean,
      disabled: false
    },
    dictKey: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: undefined
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    format: {
      type: Function,
      default: (item) => item
    },
    mode: {
      type: String,
      default: 'default'
    }
  },
  created() {
    this.onFetch()
  },
  data() {
    return {
      currentValue: this.value,
      options: []
    }
  },
  watch: {
    // 事件顺序不对会可能导致表单校验异常
    value(val) {
      if (val !== this.currentValue) {
        this.currentValue = val
      }
      // this.$emit('change', val)
    },
    currentValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    search(){
      this.$emit("onSearch",this.currentValue)
    },
    onFetch() {
      this.$http.get('/api/1/dict/cache/items.json?key=' + this.dictKey).then((response) => {
        this.options = this.format(response.result)
      })
    }
  }
}
</script>

<style scoped>

</style>
